export const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 109">
    <defs />
    <g fill="none">
      <g>
        <path fill="#e4592a" d="M134 66.3h1.5l.9 42.7h-3.2z" />
        <path
          fill="#26335b"
          d="M163.1 90.6h5.2v10.3a19.6 19.6 0 01-10.8 3.5 14 14 0 01-12.3-6.7 13.8 13.8 0 01-1.8-7c0-2.5.6-4.8 1.9-6.9s3-3.7 5.2-4.9 4.6-1.8 7.3-1.8a16.6 16.6 0 0110.6 4l-3.4 4.3a11 11 0 00-7.2-3c-1.5 0-2.9.4-4.2 1.1s-2.3 1.7-3 3a8.8 8.8 0 000 8.5 8.1 8.1 0 009.7 3.8c.9-.3 1.8-.6 2.6-1.1v-7.1zM193 78.9c2.2 1.2 3.9 2.8 5.1 4.9s1.9 4.4 1.9 6.9-.6 4.9-1.9 6.9c-1.2 2.1-2.9 3.7-5.1 4.9s-4.6 1.8-7.2 1.8-5-.6-7.2-1.8-3.9-2.8-5.1-4.9a13.8 13.8 0 010-13.9c1.2-2.1 2.9-3.7 5.1-4.9a14.8 14.8 0 0114.4.1m-11.2 4.5a7.9 7.9 0 00-3 3 8.8 8.8 0 000 8.5 8.1 8.1 0 007.1 4.2 7.7 7.7 0 006.9-4.2 8.9 8.9 0 000-8.5 8 8 0 00-11-3M0 78.7h3.2v23.9H0zm12 .1l.5.4 13.9 18-.1-.8V78.7H29v23.9h-1.6l-.6-.1-.5-.4L12.4 84l.1.8v17.7H9.6V78.7h1.7l.7.1m25.2 0l.5.4 13.9 18-.1-.8V78.7h2.8v23.9h-1.6l-.6-.1-.5-.4L37.7 84l.1.8v17.7H35V78.7h1.7l.5.1m45.2 11.9a13 13 0 01-3.3 8.8c-1 1.1-2.3 1.9-3.7 2.5-1.5.6-3.1.9-4.8.9-1.8 0-3.4-.3-4.8-.9a10.5 10.5 0 01-6.1-6.4c-.6-1.5-.9-3.1-.9-4.9a13 13 0 013.3-8.8c1-1.1 2.3-1.9 3.7-2.5s3-.9 4.8-.9 3.4.3 4.8.9c1.5.6 2.7 1.4 3.7 2.5a12.8 12.8 0 013.3 8.8m-3.4 0c0-1.5-.2-2.8-.6-4s-1-2.2-1.7-3-1.6-1.4-2.7-1.9c-1-.4-2.2-.7-3.5-.7a8.1 8.1 0 00-7.9 5.6c-.4 1.2-.6 2.5-.6 4s.2 2.8.6 3.9c.4 1.2 1 2.1 1.7 3a7.7 7.7 0 006.2 2.5c1.3 0 2.5-.2 3.5-.6s1.9-1 2.7-1.9c.7-.8 1.3-1.8 1.7-3s.6-2.5.6-3.9m4.1-12h2.6l.7.2c.2.1.3.3.4.6l6.8 16.9.4 1.2.4 1.4.3-1.4.4-1.2 6.7-16.9.4-.5c.2-.2.4-.2.7-.2h2.6l-9.7 23.9h-2.9zm42.9 23.9h-2.5l-.7-.2c-.2-.1-.3-.3-.4-.6l-2.2-5.8h-10.7l-2.2 5.8-.4.5c-.2.2-.4.2-.7.2h-2.5l9.6-23.9h3.3zm-15.6-8.9h8.9l-3.8-9.7-.7-2.3a5 5 0 01-.4 1.3l-.3 1z"
        />
        <path
          fill="#e4592a"
          d="M118.9 15.8a22.7 22.7 0 0012.4 38.5l.1-3a19.7 19.7 0 1117.4-33.2 19.7 19.7 0 01-10.4 33.1l.1 3a22.6 22.6 0 10-19.6-38.4z"
        />
        <path
          fill="#f3a81d"
          d="M138 32.1l.4 19.2A19.6 19.6 0 10121 18a19.6 19.6 0 0010.4 33.4l.4-19.2z"
        />
      </g>
      <path d="M141.5 26.1h-13.3v28.5h3.2v-.3c-1.8-.3-3.1-.7-3.1-.7l1.9-27.3 9.4-.1 1.8 27.5s-1.1.4-3 .7v.3l-.4.1h3.4z" />
      <path
        fill="#fff"
        d="M131.4 51.3l.4-19.2 6.2-.1.4 19.2.1 3c1.8-.3 3-.7 3-.7L139.7 26l-9.4.1-1.9 27.3s1.3.4 3.1.7z"
        opacity=".3"
      />
      <path
        fill="#e4592a"
        d="M134.9 30h-2.6c-.5 1.9-.9 3.9-.9 6 0 4.5 1.4 8.7 3.5 12.1a22 22 0 002.5-18.1h-2.5"
      />
      <path
        fill="#f3a81d"
        d="M134.9 31h-1.6a13.2 13.2 0 001.6 11.1 14 14 0 001.6-11.1z"
      />
      <path fill="#171d3c" d="M134.9 29.5L120.7 38l14.2-21.3L149 38.1z" />
      <path
        fill="#d6d8d3"
        d="M134.9 32.1h4.4A38.7 38.7 0 00134.9 1a38.7 38.7 0 00-4.4 31.1h4.4"
      />
      <path
        fill="#26335b"
        d="M134.8 7.3l3.3.2c-.9-2.3-2-4.5-3.3-6.6a36 36 0 00-3.3 6.5l3.3-.1m2.5 4.7c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.2 2.5 2.5"
      />
      <path
        fill="#fff"
        d="M136.5 12c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7.8-1.7 1.7-1.7c1 0 1.7.8 1.7 1.7"
      />
      <path
        fill="#26335b"
        d="M134.9 22l-5.9.1c0 3.5.5 6.9 1.4 10.2l4.5-.2 4.5.2c.9-3.2 1.4-6.6 1.4-10.1-1.9-.2-3.9-.2-5.9-.2"
      />
    </g>
  </svg>
)

export const LogoBackoffice = ({ color }: { color: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170 47" color={color}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M138.644 34.167h4.42v8.863a14.661 14.661 0 01-4.335 2.151c-1.7.517-3.23.86-4.845.86-2.21 0-4.25-.515-6.12-1.548-1.785-1.033-3.23-2.41-4.336-4.216-1.02-1.807-1.53-3.786-1.53-6.024 0-2.15.51-4.13 1.615-5.937 1.105-1.807 2.55-3.183 4.42-4.216 1.87-1.033 3.911-1.549 6.206-1.549 1.7 0 3.315.344 4.93.947 1.616.602 2.976 1.462 4.08 2.495l-2.89 3.7c-.85-.774-1.785-1.463-2.89-1.893-1.105-.43-2.21-.688-3.23-.688-1.275 0-2.465.344-3.57.946a6.184 6.184 0 00-2.55 2.582c-.595 1.118-.935 2.323-.935 3.613a7.7 7.7 0 00.935 3.7c.595 1.12 1.445 1.98 2.55 2.668 1.105.602 2.295.946 3.57.946.68 0 1.36-.086 2.125-.344.765-.258 1.53-.516 2.21-.946v-6.11h.17zM164.061 24.1c1.87 1.033 3.315 2.41 4.335 4.216 1.02 1.807 1.616 3.786 1.616 5.937 0 2.152-.51 4.217-1.616 5.938-1.02 1.807-2.465 3.183-4.335 4.216-1.87 1.033-3.91 1.549-6.12 1.549s-4.25-.516-6.12-1.549-3.316-2.41-4.336-4.216c-1.02-1.807-1.615-3.786-1.615-6.024 0-2.15.51-4.13 1.615-5.937 1.02-1.807 2.465-3.183 4.335-4.216 1.87-1.033 3.91-1.549 6.12-1.549 2.296.086 4.336.602 6.121 1.635m-9.52 3.872c-1.106.602-1.956 1.549-2.55 2.581-.596 1.12-.936 2.324-.936 3.614a7.7 7.7 0 00.935 3.7c.595 1.119 1.445 1.98 2.55 2.668 1.02.688 2.21.946 3.486.946 1.275 0 2.38-.344 3.4-.946s1.87-1.549 2.465-2.668a7.7 7.7 0 00.935-3.7c0-1.29-.34-2.495-.935-3.614a6.52 6.52 0 00-2.465-2.58 6.752 6.752 0 00-3.4-.947c-1.275 0-2.38.344-3.485.946" />
        <g>
          <path d="M0 23.928h2.72v20.565H0zM10.2 24.014c.086.086.256.172.426.344l11.816 15.489c0-.259-.085-.517-.085-.689v-15.23h2.295v20.565h-1.36c-.255 0-.425 0-.51-.086-.17-.086-.255-.172-.425-.344L10.54 28.488c0 .259 0 .517.085.689v15.23H8.16v-20.48h1.445c.255 0 .425 0 .595.087M31.622 24.014c.085.086.255.172.425.344l11.816 15.489c0-.259-.085-.517-.085-.689v-15.23h2.38v20.565h-1.36c-.255 0-.425 0-.51-.086-.17-.086-.255-.172-.425-.344L32.047 28.488c0 .259 0 .517.085.689v15.23h-2.38v-20.48h1.445c.085 0 .34 0 .425.087M70.045 34.253c0 1.55-.255 2.926-.765 4.217-.51 1.29-1.19 2.41-2.04 3.356-.85.946-1.956 1.634-3.146 2.15a10.768 10.768 0 01-4.08.775c-1.53 0-2.89-.258-4.08-.774-1.19-.517-2.295-1.205-3.145-2.151-.85-.947-1.53-2.066-2.04-3.356s-.766-2.668-.766-4.217c0-1.548.255-2.925.765-4.216.51-1.29 1.19-2.41 2.04-3.356.85-.946 1.956-1.634 3.146-2.15 1.19-.517 2.55-.775 4.08-.775 1.53 0 2.89.258 4.08.774 1.275.517 2.296 1.205 3.146 2.151.85.947 1.53 2.066 2.04 3.356.51 1.205.765 2.668.765 4.216m-2.89 0c0-1.29-.17-2.409-.51-3.441a7.527 7.527 0 00-1.446-2.582c-.595-.688-1.36-1.204-2.295-1.635a7.975 7.975 0 00-2.975-.602c-1.105 0-2.04.172-2.975.602-.85.345-1.615.947-2.295 1.635a7.527 7.527 0 00-1.445 2.582c-.34 1.032-.51 2.15-.51 3.441s.17 2.41.51 3.356c.34 1.033.85 1.807 1.445 2.582.595.688 1.36 1.204 2.295 1.635.85.344 1.87.516 2.975.516s2.125-.172 2.975-.516A5.973 5.973 0 0065.2 40.19a7.527 7.527 0 001.446-2.582c.34-1.032.51-2.15.51-3.356M70.64 23.928h2.21c.255 0 .425.086.595.172.17.086.255.258.34.516l5.78 14.542c.17.344.255.689.34 1.033.085.344.255.774.34 1.204.085-.43.17-.774.255-1.204.085-.344.255-.775.34-1.033l5.696-14.542c.085-.172.17-.344.34-.43.17-.172.34-.172.595-.172h2.21l-8.245 20.565H78.97l-8.33-20.651zM107.107 44.493h-2.125c-.255 0-.425-.086-.595-.172-.17-.086-.255-.258-.34-.516l-1.87-4.991H93.08l-1.87 4.99c-.085.173-.17.345-.34.43-.17.173-.34.173-.595.173h-2.125l8.16-20.565h2.806l7.99 20.651zm-13.26-7.658h7.565l-3.23-8.347c-.17-.516-.425-1.204-.595-1.979-.085.43-.17.775-.34 1.119-.085.344-.17.602-.255.86l-3.146 8.347z" />
        </g>
      </g>
      <text
        fontFamily="Montserrat-Regular, Montserrat"
        fontSize="14"
        fill="currentcolor"
        transform="translate(0 -4)"
      >
        <tspan x="36.454" y="14">
          BACK-OFFICE
        </tspan>
      </text>
    </g>
  </svg>
)

export const Logo2 = () => (
  <svg
    width="111"
    height="68"
    viewBox="0 0 126 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M81.54 33.9399C81.52 33.9399 81.51 33.9299 81.49 33.9299C81.51 33.9299 81.53 33.9299 81.54 33.9399Z"
      fill="#E76135"
    />
    <path
      d="M95.1099 10.23C89.6199 4.64999 80.6399 4.57999 75.0599 10.07C69.4799 15.56 69.4099 24.54 74.8999 30.12C76.6199 31.87 78.6799 33.07 80.8699 33.74V31.78C79.1699 31.17 77.57 30.2 76.22 28.83C71.44 23.97 71.4999 16.16 76.36 11.38C81.2199 6.59999 89.0299 6.65999 93.8099 11.52C98.5899 16.38 98.5299 24.19 93.6699 28.97C92.3599 30.26 90.83 31.19 89.21 31.77V33.72C91.31 33.07 93.2899 31.93 94.9699 30.28C100.53 24.79 100.61 15.82 95.1099 10.23Z"
      fill="#AF2026"
    />
    <path
      d="M81.03 31.85C80.97 31.83 80.92 31.81 80.86 31.79V33.75C80.87 33.75 80.88 33.76 80.9 33.76L81.03 31.85Z"
      fill="#AF2026"
    />
    <path
      d="M89.03 31.83L89.16 33.74C89.17 33.74 89.19 33.73 89.2 33.73V31.78C89.14 31.8 89.08 31.81 89.03 31.83Z"
      fill="#AF2026"
    />
    <path
      d="M82.12 16.62L88.01 16.53L89.03 31.83C89.09 31.81 89.14 31.79 89.2 31.77V16.53H80.87V31.79C80.93 31.81 80.98 31.83 81.04 31.85L82.12 16.62Z"
      fill="#EA3828"
    />
    <path
      d="M89.1999 16.5301V31.7701C90.8199 31.1801 92.3499 30.2601 93.6599 28.9701C98.5199 24.1901 98.5799 16.3801 93.7999 11.5201C89.0199 6.66011 81.2099 6.60011 76.3499 11.3801C71.4899 16.1601 71.4299 23.9701 76.2099 28.8301C77.5599 30.2001 79.1599 31.1801 80.8599 31.7801V16.5301H89.1999Z"
      fill="#EA3828"
    />
    <path
      d="M80.9 33.76C80.9 33.76 81.12 33.83 81.5 33.93C81.3 33.87 81.1 33.82 80.9 33.76Z"
      fill="white"
    />
    <path
      d="M89.15 33.75C88.89 33.82 88.64 33.9 88.38 33.96C88.87 33.84 89.15 33.75 89.15 33.75Z"
      fill="white"
    />
    <path
      d="M87.31 34.1701C87.73 34.1001 88.09 34.0301 88.38 33.9601C88.64 33.9001 88.8999 33.8201 89.1499 33.7501L89.02 31.8401C88.44 32.0401 87.8599 32.2101 87.2599 32.3201L87.31 34.1701Z"
      fill="#F1695A"
    />
    <path
      d="M82.87 32.3201C82.25 32.2101 81.64 32.0501 81.04 31.8501L80.9 33.7501C81.1 33.8101 81.3 33.8701 81.5 33.9201C81.52 33.9201 81.53 33.9301 81.55 33.9301C81.73 33.9801 81.92 34.0201 82.1 34.0501C82.17 34.0601 82.25 34.0801 82.33 34.0901C82.47 34.1201 82.62 34.1401 82.76 34.1701C82.78 34.1701 82.81 34.1801 82.83 34.1801L82.87 32.3201Z"
      fill="#F1695A"
    />
    <path
      d="M82.12 16.62L81.04 31.85C81.64 32.05 82.25 32.21 82.87 32.32L83.14 20.31L87.01 20.25L87.27 32.31C87.87 32.2 88.45 32.03 89.03 31.83L88.01 16.53L82.12 16.62Z"
      fill="#F5968C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.06 18.97C84.5 18.97 84 19 83.46 18.95C83.13 20.15 82.9 21.38 82.89 22.72C82.88 25.56 83.75 28.18 85.1 30.29C86.46 28.19 87.21 25.57 87.22 22.7299C87.22 21.4 86.99 20.1699 86.67 18.9599C86.12 18.9999 85.62 18.97 85.06 18.97Z"
      fill="#EA3828"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.06 19.5901C84.72 19.5901 84.41 19.6101 84.08 19.5801C83.88 20.3201 83.73 21.0701 83.73 21.8901C83.73 23.6301 84.26 25.2301 85.09 26.5301C85.92 25.2401 86.38 23.6401 86.38 21.9001C86.38 21.0801 86.24 20.3301 86.04 19.5901C85.71 19.6101 85.41 19.5901 85.06 19.5901Z"
      fill="#F5968C"
    />
    <path
      d="M85.07 18.6601L76.2 23.9901L85.08 10.5901L93.92 24.0101L85.07 18.6601Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.06 20.24C86.03 20.24 86.88 20.19 87.82 20.27C88.39 18.2 88.79 16.09 88.79 13.8C88.8 8.91003 87.37 4.41003 85.04 0.780029C82.7 4.39003 81.36 8.90003 81.36 13.78C81.36 16.07 81.75 18.18 82.31 20.26C83.24 20.18 84.09 20.24 85.06 20.24Z"
      fill="#CFD2CD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.05 4.76003C85.76 4.76003 86.46 4.81003 87.13 4.89003C86.57 3.43003 85.86 2.05003 85.04 0.780029C84.22 2.04003 83.53 3.42003 82.97 4.88003C83.64 4.80003 84.33 4.75003 85.05 4.76003Z"
      fill="#414142"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M86.6 7.68013C86.6 8.53013 85.91 9.22013 85.05 9.22013C84.2 9.22013 83.5099 8.53013 83.5099 7.67013C83.5099 6.82013 84.2 6.13013 85.06 6.13013C85.91 6.14013 86.6 6.83013 86.6 7.68013Z"
      fill="#AF2026"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M86.11 7.68012C86.11 8.26012 85.64 8.73012 85.05 8.73012C84.47 8.73012 84 8.26012 84 7.67012C84 7.09012 84.47 6.62012 85.06 6.62012C85.64 6.62012 86.11 7.10012 86.11 7.68012Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.07 13.9199C83.81 13.9199 82.58 13.9499 81.35 14.0099C81.36 16.2299 81.66 18.3599 82.2 20.3699C83.13 20.2899 84.08 20.2599 85.05 20.2599C86.02 20.2599 86.97 20.2999 87.9 20.3799C88.45 18.3699 88.76 16.2399 88.78 14.0199C87.57 13.9599 86.33 13.9199 85.07 13.9199Z"
      fill="#414142"
    />
    <path
      d="M84.55 41.3301H85.46L86.01 67.9701H84L84.55 41.3301Z"
      fill="#EA3828"
    />
    <path
      d="M102.72 56.5101H105.95V62.9201C105.07 63.5601 104.02 64.0901 102.79 64.4901C101.56 64.8901 100.39 65.0901 99.25 65.0901C97.6 65.0901 96.11 64.7201 94.77 63.9701C93.43 63.2201 92.38 62.2001 91.61 60.9001C90.84 59.6001 90.46 58.1501 90.46 56.5501C90.46 54.9601 90.85 53.5201 91.64 52.2301C92.43 50.9301 93.51 49.9201 94.88 49.1801C96.26 48.4401 97.78 48.0701 99.47 48.0701C100.7 48.0701 101.89 48.2901 103.06 48.7301C104.23 49.1701 105.24 49.7701 106.09 50.5201L103.99 53.1801C103.38 52.6001 102.67 52.1401 101.87 51.8101C101.07 51.4801 100.27 51.3201 99.47 51.3201C98.51 51.3201 97.63 51.5501 96.84 52.0201C96.05 52.4801 95.42 53.1101 94.97 53.9101C94.51 54.7001 94.2899 55.5901 94.2899 56.5601C94.2899 57.5301 94.52 58.4301 94.99 59.2401C95.45 60.0501 96.08 60.6901 96.88 61.1501C97.67 61.6101 98.5499 61.8501 99.5099 61.8501C99.9999 61.8501 100.52 61.7701 101.09 61.6001C101.66 61.4301 102.21 61.2101 102.74 60.9301V56.5101H102.72Z"
      fill="#231F20"
    />
    <path
      d="M121.39 49.1801C122.74 49.9201 123.81 50.9401 124.58 52.2301C125.36 53.5301 125.75 54.9701 125.75 56.5501C125.75 58.1401 125.36 59.5801 124.58 60.8901C123.8 62.1901 122.74 63.2201 121.39 63.9701C120.04 64.7201 118.54 65.0901 116.89 65.0901C115.24 65.0901 113.74 64.7201 112.39 63.9701C111.04 63.2201 109.97 62.2001 109.2 60.9001C108.42 59.6001 108.03 58.1501 108.03 56.5501C108.03 54.9601 108.42 53.5201 109.2 52.2301C109.98 50.9301 111.04 49.9201 112.38 49.1801C113.72 48.4401 115.23 48.0701 116.89 48.0701C118.54 48.0701 120.04 48.4401 121.39 49.1801ZM114.39 52.0201C113.6 52.4801 112.98 53.1201 112.53 53.9201C112.07 54.7201 111.85 55.6001 111.85 56.5601C111.85 57.5301 112.08 58.4201 112.55 59.2201C113.01 60.0201 113.63 60.6601 114.41 61.1301C115.19 61.6001 116.03 61.8401 116.94 61.8401C117.85 61.8401 118.69 61.6101 119.45 61.1401C120.21 60.6801 120.82 60.0401 121.26 59.2301C121.71 58.4201 121.93 57.5301 121.93 56.5501C121.93 55.5901 121.71 54.7101 121.26 53.9101C120.81 53.1101 120.21 52.4801 119.45 52.0101C118.69 51.5501 117.85 51.3101 116.94 51.3101C116.02 51.3201 115.17 51.5501 114.39 52.0201Z"
      fill="#231F20"
    />
    <path d="M2.85997 49.04H0.839966V63.98H2.85997V49.04Z" fill="#231F20" />
    <path
      d="M8.30999 49.11C8.39999 49.15 8.49999 49.25 8.60999 49.39L17.26 60.65C17.24 60.47 17.23 60.29 17.22 60.12C17.21 59.95 17.21 59.79 17.21 59.63V49.04H18.98V63.98H17.96C17.8 63.98 17.67 63.95 17.56 63.9C17.45 63.85 17.35 63.75 17.24 63.62L8.59999 52.37C8.60999 52.54 8.61999 52.71 8.62999 52.88C8.63999 53.05 8.63999 53.2 8.63999 53.34V63.99H6.87V49.04H7.91C8.09 49.04 8.21999 49.07 8.30999 49.11Z"
      fill="#231F20"
    />
    <path
      d="M24.07 49.11C24.16 49.15 24.26 49.25 24.37 49.39L33.02 60.65C33 60.47 32.99 60.29 32.98 60.12C32.97 59.95 32.97 59.79 32.97 59.63V49.04H34.74V63.98H33.72C33.56 63.98 33.43 63.95 33.32 63.9C33.21 63.85 33.11 63.75 33 63.62L24.36 52.37C24.37 52.54 24.38 52.71 24.39 52.88C24.4 53.05 24.4 53.2 24.4 53.34V63.99H22.63V49.04H23.67C23.85 49.04 23.99 49.07 24.07 49.11Z"
      fill="#231F20"
    />
    <path
      d="M52.27 56.5201C52.27 57.6401 52.09 58.6701 51.74 59.6001C51.39 60.5301 50.89 61.3401 50.24 62.0101C49.59 62.6801 48.82 63.2101 47.91 63.5801C47 63.9501 46 64.1401 44.9 64.1401C43.8 64.1401 42.8 63.9501 41.9 63.5801C41 63.2101 40.22 62.6901 39.57 62.0101C38.92 61.3401 38.42 60.5301 38.07 59.6001C37.71 58.6701 37.54 57.6401 37.54 56.5201C37.54 55.4001 37.72 54.3701 38.07 53.4401C38.42 52.5101 38.92 51.7001 39.57 51.0201C40.22 50.3401 40.99 49.8201 41.9 49.4401C42.8 49.0701 43.8 48.8801 44.9 48.8801C46 48.8801 47 49.0701 47.91 49.4401C48.82 49.8201 49.59 50.3401 50.24 51.0201C50.89 51.7001 51.39 52.5001 51.74 53.4401C52.09 54.3701 52.27 55.4001 52.27 56.5201ZM50.2 56.5201C50.2 55.6001 50.07 54.7801 49.82 54.0501C49.57 53.3201 49.22 52.7001 48.76 52.2001C48.3 51.7001 47.74 51.3101 47.09 51.0401C46.44 50.7701 45.71 50.6301 44.9 50.6301C44.1 50.6301 43.37 50.7701 42.72 51.0401C42.07 51.3101 41.51 51.7001 41.05 52.2001C40.59 52.7001 40.23 53.3201 39.98 54.0501C39.73 54.7801 39.61 55.6001 39.61 56.5201C39.61 57.4401 39.74 58.2601 39.98 58.9901C40.23 59.7201 40.59 60.3301 41.05 60.8301C41.51 61.3301 42.07 61.7201 42.72 61.9901C43.37 62.2601 44.1 62.3901 44.9 62.3901C45.71 62.3901 46.44 62.2601 47.09 61.9901C47.74 61.7201 48.3 61.3401 48.76 60.8301C49.22 60.3301 49.57 59.7101 49.82 58.9901C50.07 58.2601 50.2 57.4401 50.2 56.5201Z"
      fill="#231F20"
    />
    <path
      d="M52.7599 49.04H54.38C54.56 49.04 54.71 49.09 54.82 49.18C54.93 49.27 55.01 49.39 55.07 49.52L59.2899 60.06C59.3899 60.3 59.48 60.55 59.56 60.83C59.64 61.11 59.7199 61.4 59.7899 61.69C59.8499 61.39 59.92 61.1 59.99 60.83C60.06 60.55 60.15 60.29 60.24 60.06L64.44 49.52C64.49 49.4 64.57 49.29 64.69 49.19C64.81 49.09 64.95 49.04 65.13 49.04H66.7599L60.67 63.98H58.85L52.7599 49.04Z"
      fill="#231F20"
    />
    <path
      d="M79.55 63.99H77.99C77.81 63.99 77.66 63.95 77.55 63.85C77.44 63.76 77.36 63.65 77.3 63.51L75.9 59.9H69.2L67.8 63.51C67.75 63.64 67.67 63.75 67.55 63.84C67.43 63.94 67.29 63.99 67.11 63.99H65.55L71.52 49.05H73.57L79.55 63.99ZM69.76 58.44H75.34L72.99 52.36C72.84 51.99 72.69 51.52 72.54 50.95C72.46 51.24 72.39 51.5 72.32 51.74C72.25 51.98 72.18 52.19 72.11 52.37L69.76 58.44Z"
      fill="#231F20"
    />
  </svg>
)

export const LogoSideBar = () => (
  <svg
    className="w-[3.25rem] h-[3.25rem]"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.29 51.5001C40.4009 51.5001 51.84 40.061 51.84 25.9501C51.84 11.8393 40.4009 0.400146 26.29 0.400146C12.1791 0.400146 0.73999 11.8393 0.73999 25.9501C0.73999 40.061 12.1791 51.5001 26.29 51.5001Z"
      fill="white"
    />
    <g opacity="0.6">
      <path
        d="M22.45 41.2102C22.43 41.2102 22.42 41.2002 22.4 41.2002C22.42 41.2102 22.43 41.2102 22.45 41.2102Z"
        fill="#706D6E"
      />
      <path
        opacity="0.4"
        d="M21.89 38.9001C21.83 38.8801 21.76 38.8501 21.7 38.8301V41.0001C21.71 41.0001 21.73 41.0101 21.74 41.0101L21.89 38.9001Z"
        fill="#302C2D"
      />
      <path
        opacity="0.4"
        d="M30.76 38.8801L30.9 41.0001C30.92 41.0001 30.93 40.9901 30.95 40.9901V38.8201C30.88 38.8401 30.82 38.8601 30.76 38.8801Z"
        fill="#302C2D"
      />
      <path
        d="M21.74 41.0203C21.74 41.0203 21.99 41.1003 22.41 41.2003C22.18 41.1403 21.96 41.0803 21.74 41.0203Z"
        fill="white"
      />
      <path
        d="M30.9 41.0002C30.61 41.0802 30.33 41.1602 30.04 41.2302C30.58 41.1102 30.9 41.0002 30.9 41.0002Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M28.85 41.4701C29.32 41.4001 29.72 41.3101 30.04 41.2401C30.33 41.1701 30.61 41.0901 30.9 41.0001L30.76 38.8801C30.12 39.1001 29.47 39.2901 28.81 39.4101L28.85 41.4701Z"
        fill="#7F7D7E"
      />
      <path
        opacity="0.4"
        d="M23.92 39.4202C23.23 39.3002 22.55 39.1201 21.89 38.9001L21.74 41.0101C21.96 41.0801 22.18 41.1401 22.41 41.2001C22.43 41.2001 22.44 41.2102 22.46 41.2102C22.66 41.2602 22.87 41.3102 23.07 41.3502C23.15 41.3702 23.24 41.3801 23.32 41.4001C23.48 41.4301 23.64 41.4602 23.8 41.4902C23.83 41.4902 23.85 41.5002 23.88 41.5002L23.92 39.4202Z"
        fill="#7F7D7E"
      />
      <g opacity="0.4">
        <path
          d="M37.51 14.9C31.41 8.70003 21.44 8.62004 15.25 14.72C9.05001 20.82 8.97001 30.79 15.07 36.98C16.98 38.92 19.26 40.26 21.69 41V38.83C19.8 38.16 18.03 37.07 16.53 35.55C11.22 30.16 11.29 21.49 16.68 16.18C22.07 10.87 30.74 10.94 36.05 16.33C41.36 21.72 41.29 30.39 35.9 35.7C34.44 37.13 32.75 38.16 30.94 38.81V40.98C33.27 40.26 35.47 38.99 37.33 37.16C43.53 31.07 43.61 21.1 37.51 14.9Z"
          fill="#302C2D"
        />
        <path
          d="M23.09 21.9901L29.63 21.8901L30.76 38.8801C30.82 38.8601 30.89 38.8401 30.95 38.8201V21.9001H21.7V38.8401C21.76 38.8601 21.83 38.8901 21.89 38.9101L23.09 21.9901Z"
          fill="#535051"
        />
        <path
          d="M30.95 21.8901V38.8101C32.75 38.1601 34.45 37.1301 35.91 35.7001C41.3 30.3901 41.37 21.7201 36.06 16.3301C30.75 10.9401 22.08 10.8701 16.69 16.1801C11.3 21.4901 11.23 30.1601 16.54 35.5501C18.04 37.0701 19.82 38.1601 21.7 38.8301V21.8901H30.95Z"
          fill="#535051"
        />
        <path
          d="M23.09 21.9901L21.89 38.9001C22.56 39.1301 23.23 39.3001 23.92 39.4201L24.22 26.0901L28.52 26.0201L28.81 39.4001C29.47 39.2801 30.12 39.0901 30.76 38.8701L29.63 21.8801L23.09 21.9901Z"
          fill="#A4A2A3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.36 24.6001C25.74 24.6001 25.18 24.6301 24.58 24.5801C24.21 25.9201 23.95 27.2801 23.95 28.7601C23.94 31.9201 24.9 34.8201 26.4 37.1601C27.91 34.8301 28.74 31.9201 28.75 28.7701C28.75 27.2901 28.5 25.9201 28.14 24.5901C27.54 24.6301 26.98 24.6001 26.36 24.6001Z"
          fill="#535051"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.36 25.2803C25.98 25.2803 25.64 25.3003 25.27 25.2703C25.05 26.0903 24.89 26.9303 24.89 27.8303C24.89 29.7603 25.48 31.5403 26.4 32.9803C27.33 31.5503 27.83 29.7703 27.83 27.8403C27.83 26.9303 27.68 26.1003 27.45 25.2803C27.08 25.3103 26.74 25.2903 26.36 25.2803Z"
          fill="#A4A2A3"
        />
        <path
          d="M26.37 24.25L16.52 30.17L26.38 15.3L36.19 30.2L26.37 24.25Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.35 26.0101C27.42 26.0101 28.38 25.9601 29.41 26.0401C30.04 23.7401 30.49 21.4002 30.49 18.8502C30.5 13.4302 28.91 8.42015 26.33 4.40015C23.73 8.41015 22.25 13.4101 22.24 18.8301C22.24 21.3701 22.67 23.7201 23.29 26.0201C24.33 25.9501 25.28 26.0101 26.35 26.0101Z"
          fill="#C9C8C8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.34 8.82015C27.13 8.82015 27.9 8.87015 28.65 8.96015C28.03 7.34015 27.24 5.81015 26.33 4.40015C25.42 5.80015 24.66 7.33014 24.03 8.95014C24.78 8.87014 25.55 8.82015 26.34 8.82015Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.06 12.0701C28.06 13.0201 27.29 13.7801 26.34 13.7801C25.39 13.7801 24.63 13.0101 24.63 12.0601C24.63 11.1101 25.4 10.3501 26.35 10.3501C27.3 10.3501 28.06 11.1201 28.06 12.0701Z"
          fill="#302C2D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.52 12.0701C27.52 12.7201 26.99 13.2401 26.35 13.2401C25.7 13.2401 25.18 12.7101 25.18 12.0701C25.18 11.4201 25.71 10.9 26.35 10.9C27 10.89 27.52 11.4201 27.52 12.0701Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.37 19.0002C24.98 19.0002 23.6 19.0303 22.25 19.1003C22.26 21.5603 22.59 23.9302 23.2 26.1602C24.24 26.0802 25.29 26.0302 26.36 26.0402C27.43 26.0402 28.49 26.0902 29.52 26.1802C30.13 23.9502 30.47 21.5802 30.5 19.1202C29.14 19.0402 27.76 19.0002 26.37 19.0002Z"
          fill="#231F20"
        />
      </g>
    </g>
  </svg>
)
